import HeroContainer from "../../containers/HeroContainer.tsx";
import LearnMore from "../LearnMore.tsx";
import { Box, Typography } from "@mui/material";
import { green } from "@mui/material/colors";

const LearnMorePage = () => (
  <HeroContainer
    headerContent={
      <Box sx={{ padding: 2 }}>
        <Typography
          variant={"h3"}
          color={"primary.contrastText"}
          align={"center"}
        >
          Frequently{" "}
          <Box component={"span"} color={green[400]}>
            Asked
          </Box>{" "}
          Questions
        </Typography>
      </Box>
    }
    bodyContent={<LearnMore />}
  />
);

export default LearnMorePage;
